// extracted by mini-css-extract-plugin
export default {"logo":"TalentSection_logo__+mDbu","infos_container":"TalentSection_infos_container__Hjv9A","fullname":"TalentSection_fullname__PAlAV","email":"TalentSection_email__Gi+zT"};